import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-register-customer-dialog',
    templateUrl: './register-customer-dialog.component.html',
    standalone: false
})
export class RegisterCustomerDialogComponent implements OnInit {
  message: string;
  title: string;
  showListOfErrors = true;

  constructor(
    private translate: TranslateService,
    public dialogRef: MatDialogRef<RegisterCustomerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.showListOfErrors = true;
    if (this.data.validationErrors && this.data.validationErrors.length > 0) {
      this.title = this.translate.instant('register.dialog.title');
      if (
        this.data.validationErrors.length === 2 &&
        this.data.validationErrors[0].field === 'Kundnummer' &&
        this.data.validationErrors[1].field === 'Kontaktuppgifter'
      ) {
        this.showListOfErrors = false;
        this.title = this.translate.instant('register.dialog.title_invitation_required');
        this.message = this.translate.instant('register.dialog.primary_exists_description', {
          value1: this.data.validationErrors[0].message,
          value2: this.data.validationErrors[1].message
        });
      } else if (
        this.data.validationErrors.length === 2 &&
        this.data.validationErrors[0].field === 'Förvaltare' &&
        this.data.validationErrors[1].field === 'Kontaktuppgifter'
      ) {
        this.showListOfErrors = false;
        this.title = this.translate.instant('register.additional.manager_exists_header');
        this.message = this.translate.instant('register.additional.manager_exists_description', {
          value1: this.data.validationErrors[0].message,
          value2: this.data.validationErrors[1].message
        });
      } else if (this.data.validationErrors[0].field === 'Primär kontaktperson saknas') {
        this.showListOfErrors = false;
        this.message = this.translate.instant('register.dialog.no_primary_description', {
          value: this.data.validationErrors[0].message
        });
        this.title = this.translate.instant('register.dialog.no_primary_title');
      } else {
        this.message = this.translate.instant('register.dialog.primary_exists_description', {
          value: this.data.validationErrors[0].message
        });
      }
    }
  }
}
